import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

declare interface RouteInfo {
  parrent?: string;
  path?: string;
  title: string;
  icon: string;
  class: string;
  isparrent: boolean;
  isshow?: boolean;
  id?: string;
}
export const ROUTES: RouteInfo[] = [
  // {isshow : false,isparrent: false, path: '/home', title: 'Trang chủ', icon: 'ni-bullet-list-67 text-red', class: '' },

  { isshow: false, isparrent: true, id: "transaction", title: 'Báo cáo', icon: 'ni-chart-bar-32 text-red', class: '' },
  { isshow: false, isparrent: false, parrent: 'transaction', path: '/transaction/history', title: 'Lịch sử giao dịch', icon: 'ni-bullet-list-67 text-info', class: '' },
  { isshow: false, isparrent: false, parrent: 'transaction', path: '/transaction/batchhistory', title: 'Lịch sử mua lô', icon: 'ni-bullet-list-67 text-info', class: '' },


  { isshow: false, isparrent: true, id: "agent", title: 'Đại Lý', icon: 'ni-ungroup text-red', class: '' },
  { isshow: false, isparrent: false, parrent: 'agent', path: '/agentgroup', title: 'Nhóm đại Lý', icon: 'ni-bullet-list-67 text-info', class: '' },
  { isshow: false, isparrent: false, parrent: 'agent', path: '/agent', title: 'Đại Lý', icon: 'ni-bullet-list-67 text-info', class: '' },  
  { isshow: false, isparrent: false, parrent: 'agent', path: '/agent/balance', title: 'Số dư', icon: 'ni-money-coins text-info', class: '' },

  { isshow: false, isparrent: true, id: "account", title: 'Tài khoản', icon: 'ni-circle-08 text-red', class: '' },
  { isshow: false, isparrent: false, parrent: 'account', path: '/account', title: 'Tài khoản', icon: 'ni ni-single-02 text-info', class: '' },

  { isshow: false, isparrent: true, id: "inventory", title: 'Kho hàng', icon: 'ni-single-copy-04 text-red', class: '' },
  // { isshow: false, isparrent: false, parrent: 'pincode', path: '/pincode/uploadfile', title: 'Nhập kho', icon: 'ni-bullet-list-67 text-info', class: '' },
  { isshow: false, isparrent: false, parrent: 'inventory', path: '/pincode/searchimportmaster', title: 'Nhập kho', icon: 'ni-bullet-list-67 text-info', class: '' },
  { isshow: false, isparrent: false, parrent: 'inventory', path: '/pincode/searchpincode', title: 'Quản lý thẻ', icon: 'ni-bullet-list-67 text-info', class: '' },    
  { isshow: false, isparrent: false, parrent: 'inventory', path: '/pincode/cardstock', title: 'Xuất nhập tồn thẻ', icon: 'ni-bullet-list-67 text-info', class: '' },    
  
  { isshow: false, isparrent: false, parrent: 'inventory', path: '/pincode/storage', title: 'Kho thẻ', icon: 'ni-bullet-list-67 text-info', class: '' },    

  { isshow: false, isparrent: false, parrent: 'inventory', path: '/topup/paymenthistory', title: 'Lịch sử Topup', icon: 'ni-bullet-list-67 text-info', class: '' },
  { isshow: false, isparrent: false, parrent: 'inventory', path: '/topup/simlist', title: 'Kho sim', icon: 'ni-bullet-list-67 text-info', class: '' },    
  { isshow: false, isparrent: false, parrent: 'inventory', path: '/topup/simstock', title: 'Xuất nhập tồn Sim', icon: 'ni-bullet-list-67 text-info', class: '' },

  { isshow: false, isparrent: true, id: "config", title: 'Cấu hình', icon: 'ni-settings text-red', class: '' },
  { isshow: false, isparrent: false, parrent: 'config', path: '/service', title: 'Dịch vụ', icon: 'ni-bullet-list-67 text-info', class: '' },
  { isshow: false, isparrent: false, parrent: 'config', path: '/provider', title: 'Nhà cung cấp', icon: 'ni-bullet-list-67 text-info', class: '' },
  { isshow: false, isparrent: false, parrent: 'config', path: '/tariff', title: 'Chiết khấu', icon: 'ni-bullet-list-67 text-info', class: '' }
];

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html'
})
export class SidebarComponent implements OnInit {

  public menuItems: any[];
  public isCollapsed = true;

  constructor(private router: Router) { }

  ngOnInit() {
    this.menuItems = ROUTES.filter(menuItem => menuItem);
    this.router.events.subscribe((event) => {
      this.isCollapsed = true;
    });

  }

  toggle(item) {
  
    if (item.isparrent) {
      item.isshow = !item.isshow;
      this.menuItems.forEach(element => {
        if (element.parrent === item.id) {
          element.isshow = !element.isshow;
        }
      });

      // collpase other item
      this.menuItems.forEach(element => {
        if (element.parrent !== item.id) {
          element.isshow = false;
        }
      });
    }
    else{
      
    }    
  }

  closeMenu(){
    this.isCollapsed=!this.isCollapsed;
  }
}
